<template>
  <div></div>
</template>

<script>
//  <div>
//    Tags :
//    <a v-for="tag in tags" @click="filterByTag(tag)" class="tag">{{tag}}</a>
//  </div>
import store from '@/store';

const tags = ['react', 'vue'];

export default {
  name: 'Navigation',

  methods: {
    filterByTag(tag) {
      this.$router.push('/tag/' + tag);
    },
  },

  data() {
    return {
      tags
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue